import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../modules';

import { selectContent } from '../../modules/editor';

import SelectedContentBase from './SelectedContentBase';
import SelectedContentStyle from './SelectedContentStyle';
import SelectedContentPermalink from './SelectedContentPermalink';
import SelectedContentHeader from './SelectedContentHeader';
import SelectedContentFooter from './SelectedContentFooter';
import SelectedContentMap from './SelectedContentMap';
import SelectedContentVideo from './SelectedContentVideo';
import SelectedContentSns from './SelectedContentSns';
import SelectedContentShare from './SelectedContentShare';
import SelectedContentDonation from './SelectedContentDonation';
import SelectedContentShop from './SelectedContentShop';
import SelectedContentHtmlcode from './SelectedContentHtmlcode';
import SelectedContentPartition from './SelectedContentPartition';
import SelectedContentSpacer from './SelectedContentSpacer';
import ErrorBoundary from '../../components/ErrorBoundary';
import Alert from '../../lib/Alert';
import { TEXT_TEMPLATE } from '../../constants';

function SelectedContent({ showSelectedSidebar }) {
	const dispatch = useDispatch();

	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);
	const contents = useSelector((state: RootState) => state.editor.contents);
	const { templateId } = useSelector((state: RootState) => state.editor.email);

	const currentContent = contents?.find((item) => {
		return item.id === selectedContentId;
	});

	let styleTarget = `${selectedContentId}/style/0`;
	let currentContentStyle:any = currentContent?.content?.style?.[0];

	if (Array.isArray(currentContentStyle)) {
		currentContentStyle = currentContent?.content?.style?.[0]?.[0];
		styleTarget = `${selectedContentId}/style/0/0`;
	}

	const settingPanels:any = {
		base: SelectedContentBase,
		permalink: SelectedContentPermalink,
		header: SelectedContentHeader,
		footer: SelectedContentFooter,
		map: SelectedContentMap,
		video: SelectedContentVideo,
		sns: SelectedContentSns,
		share: SelectedContentShare,
		donation: SelectedContentDonation,
		shop: SelectedContentShop,
		htmlcode: SelectedContentHtmlcode,
		partition: SelectedContentPartition,
		spacer: SelectedContentSpacer
	}
	const currentCategory:string|undefined = currentContent?.content?.category;
	const SettingPanel = currentCategory ? settingPanels[currentCategory] : SelectedContentBase;

	const close = () => {
		dispatch(selectContent(-1));
	}

	const msg = useSelector((store) => store.editor.service.msg);
	const onInvalidBlockError = () => {
		Alert.error(msg.DEFAULT_ERROR);
		close();
	}

	return (
		<div className={!showSelectedSidebar ? 'editor-sidebar-selected-content' : 'editor-sidebar-selected-content active'}>
			<header className="selected-content-header">
				<h2>{currentContent?.content?.typeText}</h2>
				<button className="btn medium" onClick={close}>닫기</button>
			</header>

			<ErrorBoundary fallback={<></>} onError={onInvalidBlockError} resetKeys={[currentContent]}>
				<SettingPanel
					selectedContentId={selectedContentId}
					currentContent={currentContent}
				/>

				<SelectedContentStyle
					currentContent={currentContent}
					styleTarget={styleTarget}
					currentContentStyle={currentContentStyle}
				/>
			</ErrorBoundary>
		</div>
	);
}

export default SelectedContent;